// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { GridItemStyle } from "@insite/mobius/GridItem";
import { signInExistingAccountStyles } from "@steiner/Overrides/Widgets/SignIn/SignInExistingAccount";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { css } from "styled-components";

signInExistingAccountStyles.signInGridContainer = {
    gap: 20,
    css: css`
        ${GridItemStyle}:empty {
            display: none;
        }
    `,
};

signInExistingAccountStyles.rememberMeGridItem = {
    width: 12,
    css: css`
        align-items: center;
        gap: 15px;
    `,
};

signInExistingAccountStyles.signInButtonGridItem = {
    width: 12,
    css: css`
        gap: 15px;
    `,
};

signInExistingAccountStyles.labelWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 5px;
    `,
};

signInExistingAccountStyles.forgotPasswordLink = {
    typographyProps: {
        size: 12,
        weight: fontConfig.weight.semiBold,
        css: css`
            line-height: 15px;
        `,
    },
};

signInExistingAccountStyles.forgotUsernameLink = {
    typographyProps: {
        size: 12,
        weight: fontConfig.weight.semiBold,
        css: css`
            line-height: 15px;
        `,
    },
};

signInExistingAccountStyles.rememberMeCheckbox = {
    typographyProps: {
        size: 12,
        css: css`
            line-height: 15px;
        `,
    },
};

signInExistingAccountStyles.signInButton = {
    typographyProps: {
        css: css`
            line-height: 18px;
        `,
    }
};

signInExistingAccountStyles.signInExistingAccountTitle = {
    variant: "h2",
    as: "h2",
    css: css`
        margin-bottom: 16px;
    `,
};
